// config-file-error-without-content-echo.ts
//
// Moved verbatim out of effective-config-loader.ts (V2 phase 02) so the V2
// file loader (effective-config-v2-loader.ts) builds the SAME `config_invalid`
// error for its own file without an import cycle back into the main loader.

/** Shape shared by every config-loading error: `{ok:false, fieldPath, message}`. */
export interface ConfigFileLoadErr {
  ok: false;
  fieldPath: string;
  message: string;
}

/** Builds the `config_invalid` err for a global-config file that exists but could not be used — never echoes file content (may hold secrets, e.g. a PAT). */
export function configFileError(path: string, what: string, err: unknown): ConfigFileLoadErr {
  const raw = err instanceof Error ? err.message : String(err);
  // (code-review phase-02 [L2]) JSON.parse errors (and any other error text)
  // can embed a quoted excerpt of the bad input (e.g. V8's `Unexpected
  // token 'g', "glpat-secret" is not valid JSON`) — strip from the FIRST
  // double-quote onward rather than matching V8's exact `, "..."` shape, so
  // a future V8 format change (or a non-JSON.parse caller) can't reintroduce
  // a leak the old anchored regex would have missed.
  const quoteIdx = raw.indexOf('"');
  const detail = quoteIdx === -1 ? raw : raw.slice(0, quoteIdx).replace(/,\s*$/, "");
  return { ok: false, fieldPath: "(file)", message: `Global config "${path}" ${what}: ${detail}` };
}
